import React from "react";
import {Typography} from "@mui/material";
import {BaseWidget} from "./BaseWidget";

export class WeatherWidget extends BaseWidget {

  protected renderContent(content?: {}): React.ReactElement {
    return <Typography>Hello</Typography>;
  }
}